import React from 'react';
import { Badge } from 'reactstrap';

/**
 * Flags for VF / 3D / intermission, from Engine `opaque` or Kronos task screening.
 *
 * @param {object|null} screening
 * @returns {{ version: string, _3d: boolean, break: boolean }|null}
 */
export function screeningOpaqueFromPayload(screening) {
    if (!screening || typeof screening !== 'object')
        return null;
    const nested = screening.opaque && typeof screening.opaque === 'object'
        ? screening.opaque
        : {};
    const version = String(nested.version || screening.version || '').trim();
    const flags = {
        version,
        _3d: !!(Object.prototype.hasOwnProperty.call(nested, '_3d')
            ? nested._3d
            : screening._3d),
        break: !!(Object.prototype.hasOwnProperty.call(nested, 'break')
            ? nested.break
            : screening.break),
    };
    if (!flags.version && !flags._3d && !flags.break)
        return null;
    return flags;
}

const ScreeningOpaqueBadges = ({ opaque, className = 'ml-1' }) => {
    if (!opaque) {
        return null;
    }

    return (
        <>
            {opaque.version && (
                <Badge color="secondary" className={className}>{opaque.version}</Badge>
            )}
            {opaque._3d && (
                <Badge color="danger" className={className}>3D</Badge>
            )}
            {opaque.break && (
                <Badge color="info" className={className}>
                    <i className="fa fa-pause" aria-hidden="true" />
                </Badge>
            )}
        </>
    );
};

export default ScreeningOpaqueBadges;
